import {OnboardingStyle} from "@components/onboarding/onboarding.style";
import {createStyles, Theme} from "@material-ui/core";

export const CalendarSyncStyles = (theme: Theme) => createStyles({
    ...OnboardingStyle(theme),
    middleContent: {
        ...OnboardingStyle(theme).middleContent,
        justifyContent: 'center',
        gap: theme.spacing(3.5),
    },
});



// WEBPACK FOOTER //
// ./src/components/onboarding/steps/StepCalendarSync/calendarSync.styles.ts